/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext } from 'react';
import type { VueFormatterServiceInterfaceV1 } from '@oneaudi/vue-formatter-service';
import type { GfaLocaleServiceV1 } from '@volkswagen-onehub/gfa-locale-service';
import type { AudiFootnoteRefernceServiceScopeManagerInterfaceV3 } from '@oneaudi/footnote-reference-service';

type ContentContextState = {
  featureAppId: string;
  content?: any;
  trackingService?: any;
  loggerService?: any;
  localeService: GfaLocaleServiceV1;
  // vueFormatterService: VueFormatterFeatureServiceInterfaceV1; TODO: Confirm the below is the correct replacement
  vueFormatterService: VueFormatterServiceInterfaceV1;
  footnoteReferenceService: AudiFootnoteRefernceServiceScopeManagerInterfaceV3;
};

export const ContentContext = createContext<ContentContextState>({
  featureAppId: '',
  loggerService: console,
  localeService: {} as GfaLocaleServiceV1,
  // vueFormatterService: {} as VueFormatterFeatureServiceInterfaceV1 TODO: Confirm the below is the correct replacement
  vueFormatterService: {} as VueFormatterServiceInterfaceV1,
  footnoteReferenceService: {} as AudiFootnoteRefernceServiceScopeManagerInterfaceV3,
});
